const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1366px",
  desktop: "1440px",
  desktopL: "1920px",
  /* Landing redesign breakpoints (see Tendbe landing implementation guide) */
  compact: "370px",
  phone: "680px",
  tabletWide: "900px",
  desktopS: "1150px",
  desktopXL: "1550px",
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktopL})`,
  compact: `(min-width: ${size.compact})`,
  phone: `(min-width: ${size.phone})`,
  tabletWide: `(min-width: ${size.tabletWide})`,
  desktopS: `(min-width: ${size.desktopS})`,
  desktopXL: `(min-width: ${size.desktopXL})`,
};

export const deviceMax = {
  mobileSMax: `(max-width: ${size.mobileS})`,
  mobileMMax: `(max-width: ${size.mobileM})`,
  mobileLMax: `(max-width: ${size.mobileL})`,
  tabletMax: `(max-width: ${size.tablet})`,
  laptopMax: `(max-width: ${size.laptop})`,
  laptopLMax: `(max-width: ${size.laptopL})`,
  desktopMax: `(max-width: ${size.desktop})`,
  desktopLMax: `(max-width: ${size.desktopL})`,
  compactMax: `(max-width: ${size.compact})`,
  phoneMax: `(max-width: ${size.phone})`,
  tabletWideMax: `(max-width: ${size.tabletWide})`,
  desktopSMax: `(max-width: ${size.desktopS})`,
};

export const reducedMotion = `(prefers-reduced-motion: reduce)`;
